var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFullscreenOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6238",
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13959",
    fill: "none",
    stroke: "#006e94",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27029",
    d: "M6.634 12.062V6.633h5.428"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27030",
    d: "M19.938 6.633h5.428v5.429"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27031",
    d: "M25.367 19.939v5.429h-5.428"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27032",
    d: "M12.062 25.368H6.634V19.94"
  }))));
}
export default SvgIcFullscreenOn;